import desktopIcon from "assets/icons/desc.svg";
import phoneIcon from "assets/icons/mob.svg";

import styles from './Device.module.scss';

type Props = {
  devices: string[];
};

export function Devices ({ devices }: Props) {
  return (
      <div className={`devices ${styles['devices']}`}>
        <div
          className={
            `${styles['devices-item']} ${devices.includes('desk') ? '' : styles['devices-item--hidden']}`
          }
        >
          <img src={desktopIcon} alt="Desktop Icon" />
        </div>
        <div
          className={
            `${styles['devices-item']} ${devices.includes('mob') ? '' : styles['devices-item--hidden']}`
          }
        >
          <img src={phoneIcon} alt="Phone Icon" />
        </div>
      </div>
  );
};
